// @Version: 1.0.0
import { Component, Input } from '@angular/core';
import { TRANSLATE_PATH } from '../../shared.model';

@Component({
   selector: 'app-no-mobile',
   templateUrl: './no-mobile.component.html',
   standalone: false
})
export class NoMobileComponent {
   public TRANSLATE_PATH = TRANSLATE_PATH;
   @Input() path = TRANSLATE_PATH.NO_MOBILE;

   constructor () {}
}